import React from "react";
import "../css/Features.css";

export default function Features() {
  const features = [
    { title: "Our Aim", label: "Purpose", text: "To inspire and equip students with the knowledge and skills needed to excel in STEM fields, fostering a lifelong love for learning and innovation.", accent: "coral", image: "/images/aim.png" },
    { title: "Our Vision", label: "Future", text: "To ignite curiosity in young minds, foster creativity through hands-on learning, and inspire innovation for a brighter future.", accent: "teal", image: "/images/telescope.png" },
    { title: "Our Mission", label: "Action", text: "To empower students with experiential STEM education, nurturing problem-solving skills and a passion for discovery.", accent: "yellow", image: "/images/rocket.png" },
  ];

  return (
    <section className="ms-features-section" aria-labelledby="features-title">
      <div className="ms-features-grid" aria-hidden="true" />
      <div className="ms-features-glow ms-features-glow-blue" aria-hidden="true" />
      <div className="ms-features-glow ms-features-glow-yellow" aria-hidden="true" />
      <div className="container ms-features-container">
        <header className="ms-features-heading">
          <div className="ms-features-kicker"><span /> WHAT DRIVES US</div>
          <h2 id="features-title">Purpose at the heart of <span>every idea.</span></h2>
          <p>Our aim, vision and mission guide how we make technology learning practical, inspiring and meaningful for every student.</p>
        </header>
        <div className="ms-features-list">
          {features.map((feature, index) => (
            <article className={`ms-feature-card ${feature.accent}`} key={feature.title}>
              <span className="ms-feature-number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
              <div className="ms-feature-icon-wrap"><img src={feature.image} alt="" className="ms-feature-image" /></div>
              <span className="ms-feature-label">{feature.label}</span>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
              <span className="ms-feature-line" aria-hidden="true" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
